<template>
  <div class="loading-container">
    <v-loading :loader="loader" :message="message">
      <template slot="spinner">
        <div class="v-loading">
          <img class="loading-img" src="../assets/loading.gif" />
          <span class="loading-message">{{ message }}</span>
        </div>
      </template>
    </v-loading>
  </div>
</template>
<script>
export default {
  name: 'loading',

  props: {
    loader: String,
    message: String,
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
.loading-container
  .v-loading
    width: 100%;
    position: absolute;
    height: 100%;
    z-index: 9999;
    top: 0;
    left: 0;
    background: rgba(242,242,242,0.3);
    .loading-img
      position: absolute;
      left: 50%;
      top: 20vh;
      margin-left: -32px;
      margin-top: -32px;
    .loading-message
      position: absolute;
      left: 50%;
      top: calc(20vh + 40px);
      transform: translate(-50%, -50%);
      color: #db5868;
</style>
